import React from "react";
import { Home, CalendarPlus, FileText, MessageSquare, User } from "lucide-react";
import DashboardLayout from "@/components/dashboard/DashboardLayout";
import PortalSwitch from "@/components/dashboard/PortalSwitch";

export default function DoctorLayout() {
  const nav = [
    { to: "/espace", label: "Accueil", icon: Home, end: true },
    { to: "/espace/reserver", label: "Réserver", icon: CalendarPlus },
    { to: "/espace/demandes", label: "Mes demandes", icon: FileText },
    { to: "/espace/messages", label: "Messagerie", icon: MessageSquare },
    { to: "/espace/profil", label: "Mon profil", icon: User },
  ];
  return <DashboardLayout nav={nav} portalSwitch={<PortalSwitch />} />;
}
